import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getComingSoonFooterData = async () => {
  const data = await fetchData(ENDPOINTS.GET.COMING_SOON_FOOTER, {
    method: METHODS.GET,
  });
  return data;
};
